export const locations = {
  countries: "accounts/country/",
  cities: (id: number) => `accounts/city/?id=${id}`,
  geocoding: {
    search: "accounts/geocoding/search/",
    reverse: "accounts/geocoding/reverse/",
    cityBounds: "accounts/geocoding/city-bounds/",
  },
};
